import React, { Component } from 'react'

class Notification extends Component {
  render() {
    return (

      <>

        <div class={this.props.message.type}  role="alert">
          <strong>{this.props.message.info}</strong>
        </div>


      </>
    )
  }
}

export default Notification